import React from "react";
import { PageTitle } from "./pageTitle";

import "../App.css";

export const AccountCancellation = () => {
  return (
    <main className="inner-page inner-page--legal">
      <PageTitle title="Política para encerramento de contas" />
      <div className="container inner-page__body">
      <div id="bodyContrato" className="inner-page__card inner-page__prose text-just">
        <p></p>

        <p>Prezado(a) cliente!</p>
        <p>
          Segue abaixo o procedimento a ser adotado para encerramento de conta:
        </p>

        <p>
          1 – Em sua conta, basta acessar o perfil de usuário, tem um ícone
          destacado no lado direito da tela DELETAR CONTA em vermelho.
        </p>

        <p>2 – No perfil, selecionar a opção “deletar conta”</p>

        <p>3 – Feito isso, basta concluir o fluxo de encerramento.</p>

        <p>
          4 – Observação: Para que o fluxo seja concluído a conta precisa estar
          sem saldo, ou seja, deve ocorrer a transferência de eventual saldo
          remanescente pelo titular para conta diversa na própria ou em outra
          instituição.
        </p>

        <p>
          5 – Concluído esse fluxo, a solicitação será enviada para o setor
          responsável analisar e, estando de acordo, efetivar o encerramento da
          referida conta.
        </p>

        <p>
          Havendo qualquer pendência, o setor responsável entrará em contato
          para auxiliá-lo. Em caso de dúvida, permanecemos à sua disposição
          através dos nossos canais oficiais!
        </p>
      </div>
      </div>
    </main>
  );
};
